import { DownloadAppContainer } from "@/components/organisms/DownloadApp/DownloadAppContainer";

/**
 * Download App Page
 * Displays the download app screen with QR code and CTA.
 * Figma: ACP — Registration Redesign 2026 — Handoff (node 4001:58499)
 */
export function DownloadAppPage() {
  return <DownloadAppContainer />;
}
